import { jsxs as e, jsx as o } from "react/jsx-runtime";
const r = ({ className: t }) => /* @__PURE__ */ e(
  "svg",
  {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: t,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M35.0016 32.0265V26.7511C35.0016 23.8025 35.0016 22.3282 34.1014 21.9613C33.2011 21.5944 32.1416 22.6369 30.0226 24.7218C28.9195 25.8072 28.2784 26.0407 26.7378 26.0407C25.3723 26.0407 24.6896 26.0407 24.1991 26.3631C23.1932 27.0245 23.335 28.3266 23.335 29.3888C23.335 30.451 23.1932 31.7531 24.1991 32.4145C24.6896 32.7369 25.3723 32.7369 26.7378 32.7369C28.2784 32.7369 28.9195 32.9704 30.0226 34.0557C32.1416 36.1407 33.2011 37.1832 34.1014 36.8163C35.0016 36.4494 35.0016 34.9751 35.0016 32.0265Z",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M20.0026 36.8888H17.8814C12.4461 36.8888 9.72838 36.8888 7.84105 35.5591C7.3003 35.1781 6.82024 34.7263 6.41544 34.2173C5.00261 32.441 5.0026 29.8832 5.0026 24.7676V20.5252C5.0026 15.5865 5.00261 13.1172 5.78417 11.145C7.04063 7.9745 9.69783 5.4736 13.0665 4.29105C15.162 3.55546 17.7856 3.55546 23.0329 3.55546C26.0314 3.55546 27.5306 3.55546 28.728 3.97579C30.653 4.65154 32.1714 6.08062 32.8893 7.89236C33.3359 9.01933 33.3359 10.4304 33.3359 13.2524V16.8888",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M5.0013 20.2222C5.0013 17.1539 7.48861 14.6666 10.5569 14.6666C11.6665 14.6666 12.9747 14.861 14.0536 14.572C15.0122 14.3151 15.7609 13.5664 16.0178 12.6078C16.3068 11.5289 16.1124 10.2207 16.1124 9.11106C16.1124 6.04281 18.5997 3.5555 21.668 3.5555",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  r as AudioFileIcon
};
